import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { GetTrailerListRequest, GetTrailerListResponse } from '../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { StartNewVoucherDataClass } from '../../../shared/models/start-new-voucher-data.model';

@Component({
  templateUrl: 'pick-trailer.component.html',
  styleUrls: ['./pick-trailer.component.scss']
})
export class PickTrailerComponent implements OnInit {
  trailerListResponse: GetTrailerListResponse | null = null;
  loading: boolean = true;
  searchText: string = '';

  get filteredTrailers() {
    if (!this.trailerListResponse?.trailers) return [];
    // Log trailers that are already picked (driverReserved is set)
    const pickedTrailers = this.trailerListResponse.trailers.filter(trailer => !!trailer.driverReserved);
    if (pickedTrailers.length > 0) {
    }
    if (this.searchText.length > 0) {
      const lowerSearch = this.searchText.toLowerCase();
      return this.trailerListResponse.trailers.filter(trailer =>
        trailer.trailerNumber && trailer.trailerNumber.toLowerCase().startsWith(lowerSearch)
      );
    }
    return this.trailerListResponse.trailers;
  }

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadTrailerList();
  }

loadTrailerList() {
    this.loading = true;
    const request: GetTrailerListRequest = {};
    this.courierService.getTrailerList(request).subscribe(
      (response: GetTrailerListResponse) => {
        if (response?.trailers) {
        }
        this.trailerListResponse = response;
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching trailer list:', error);
        this.loading = false;
      }
    );
  }

  continueNextStep(trailerId: number, trailerNumber: string | null) {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData) {
      startNewVoucherData.trailerId = trailerId;
      this.activeUserLocalDataService.setStartNewVoucherData(startNewVoucherData);
      this.router.navigate(['/rule-check']);
    }
  }

  continueWithoutTrailer() {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData) {
      startNewVoucherData.trailerId = undefined;
      this.activeUserLocalDataService.setStartNewVoucherData(startNewVoucherData);
      this.router.navigate(['/rule-check']);
    }
  }

  navigateToVoucher() {
    this.router.navigate(['/voucher']);
  }
  }

